import { useAudienceBuilderStore } from "@/stores/AudienceBuilderStore";
import { useMapStore } from "@/stores/MapStore";
import { useMetaAudienceStore } from "@/stores/MetaAudienceStore";
import { useErrorStore } from "@/stores/ErrorStore";

export const AudienceBuilderStores = [
  useAudienceBuilderStore,
  useMapStore,
  useMetaAudienceStore,
  useErrorStore,
];

export const AudienceBuilderChannel = {
  async received(payload) {
    if (payload.status === "error") {
      const task = Object.keys(this.audienceBuilderStore.taskIds).find(
        (task) => this.audienceBuilderStore.taskIds[task] === payload.id,
      );
      this.audienceBuilderStore.taskIds[task] = undefined;
      this.audienceBuilderStore.loading[task] = false;
      if (task === "kpiHistograms" || task === "surveyKpiHistograms") {
        this.audienceBuilderStore.errors[task] = payload.message;
        this.audienceBuilderStore.taskIds[task] = undefined;
      } else {
        this.errorStore.showError(payload.message);
      }
      return;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.kpiHistograms) {
      this.audienceBuilderStore.kpiHistograms = payload.data.kpis;
      this.audienceBuilderStore.taskIds.kpiHistograms = undefined;
      this.audienceBuilderStore.loading.kpiHistograms = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.surveyKpiHistograms) {
      this.audienceBuilderStore.surveyKpiHistograms = payload.data.kpis;
      this.audienceBuilderStore.taskIds.surveyKpiHistograms = undefined;
      this.audienceBuilderStore.loading.surveyKpiHistograms = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.kpiHistogram) {
      if (payload.data && payload.data.total_person_count === 0) {
        this.errorStore.showError(
          "No data found for the selected geography and kpi",
        );
      }
      this.audienceBuilderStore.kpiHistogram = payload.data;
      this.audienceBuilderStore.taskIds.kpiHistogram = undefined;
      this.audienceBuilderStore.loading.kpiHistogram = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.preview) {
      this.audienceBuilderStore.preview = payload.data;
      this.audienceBuilderStore.taskIds.preview = undefined;
      this.audienceBuilderStore.loading.preview = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.counts) {
      this.audienceBuilderStore.counts = payload.data.audience_count;
      this.audienceBuilderStore.taskIds.counts = undefined;
      this.audienceBuilderStore.loading.counts = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.geographyCount) {
      this.audienceBuilderStore.geographyCount = payload.data.geography_count;
      this.audienceBuilderStore.taskIds.geographyCount = undefined;
      this.audienceBuilderStore.loading.geographyCount = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.tvMonths) {
      this.audienceBuilderStore.tvMonths = payload.data;
      this.audienceBuilderStore.taskIds.tvMonths = undefined;
      this.audienceBuilderStore.loading.tvMonths = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.callsigns) {
      this.audienceBuilderStore.callsigns = payload.data?.callsigns;
      this.audienceBuilderStore.taskIds.callsigns = undefined;
      this.audienceBuilderStore.loading.callsigns = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.networks) {
      this.audienceBuilderStore.networks = payload.data?.networks;
      this.audienceBuilderStore.taskIds.networks = undefined;
      this.audienceBuilderStore.loading.networks = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.tvPrograms) {
      this.audienceBuilderStore.tvPrograms = payload.data?.programs;
      this.audienceBuilderStore.taskIds.tvPrograms = undefined;
      this.audienceBuilderStore.loading.tvPrograms = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.programTimes) {
      this.audienceBuilderStore.programTimes = payload.data?.time_ranges;
      this.audienceBuilderStore.taskIds.programTimes = undefined;
      this.audienceBuilderStore.loading.programTimes = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.heatmap) {
      this.audienceBuilderStore.heatmap = payload.data;
      this.audienceBuilderStore.taskIds.heatmap = undefined;
      this.audienceBuilderStore.loading.heatmap = false;
      this.mapStore.setCartoLoading(false);
    }
    if (payload.id === this.audienceBuilderStore.taskIds.aiAssist) {
      this.audienceBuilderStore.aiAssist = payload.data;
      this.audienceBuilderStore.taskIds.aiAssist = undefined;
      this.audienceBuilderStore.loading.aiAssist = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.aiNameDescription) {
      this.audienceBuilderStore.aiNameDescription = payload.data;
      this.audienceBuilderStore.taskIds.aiNameDescription = undefined;
      this.audienceBuilderStore.loading.aiNameDescription = false;
    }
    if (payload.id === this.audienceBuilderStore.taskIds.createAudience) {
      if (payload.status === "error") {
        this.errorStore.showError(payload.message);
        this.audienceBuilderStore.taskIds.createAudience = undefined;
        this.audienceBuilderStore.loading.createAudience = false;
        return;
      }
      if (payload.data?.meta_audience) {
        this.metaAudienceStore.addMetaAudience(payload.data.meta_audience);
      }
      this.audienceBuilderStore.taskIds.createAudience = undefined;
      this.audienceBuilderStore.loading.createAudience = false;
    }
  },
};
